<template lang="html">
    <div class="footer">
        <h5 class="footer__title">Copyright © 2021 MIND PLATFORM SRL</h5>
    </div>
</template>

<script>
export default {
}
</script>
